import React from "react";
import RequestList from "./components/RequestList";

const Request = () => {
  return (
    <div>
      <RequestList />
      
    </div>
  );
};

export default Request;
